import { EVENTID, MICE_EVENT_ID } from './constants';

const attendeeDefault = {
  name: '',
  role: '',
  mobile: '',
  email: '',
  document: '',
  store_code: '',
  make_knowledge: '',
  company: '',
  cp_code: '',
  cp_name: '',
  lgpd: false,
  // focal_point: '',
};

const cctokenDefault = {
  number: '',
  name: '',
  country: '',
  expireAt: '',
  code: '',
  installments: 1,
};

const customerDefault = {
  name: '',
  email: '',
  mobile: '',
  document: '',
  address: '',
};

const transactionDefault = {
  promoCode: 'NOCODE',
  eventId: EVENTID,
  eventCode: MICE_EVENT_ID,
  attendees: [],
  products: [],
  paymentType: 'pix',
  customer: null,
  token: '',
  installments: 1,
};

const transactionResponseDefault = { success: false, data: null };

export {
  attendeeDefault,
  cctokenDefault,
  customerDefault,
  transactionDefault,
  transactionResponseDefault,
};
